export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_precision-gaming-12/artifacts/t4mg5sts_ChatGPT_Image_Sep_4__2026__12_23_39_PM-removebg-preview.png";
export const BRAND = "TIMEUP";
